var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h5',{staticClass:"text-14 text-oth-6 font-bold uppercase"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }